import { connect } from 'react-redux'
import Contract from './ContractDetails'
import * as contractActions from '../ContractsActions'
import * as flashMessageActions from '../../FlashMessage/FlashMessageActions'
import * as appActions from '../../App/AppActions'

const mapStateToProps = (state) => ({
    apiClientLoaded: state.apiClient.loaded,
    contract: state.contracts.selected,
    current: state.contracts.current
})

const actions = {
    ...contractActions, 
    ...flashMessageActions,
    ...appActions
}

export default connect(mapStateToProps, actions)(Contract)


// WEBPACK FOOTER //
// ./src/components/Contracts/Details/index.jsx